module.exports = __webpack_public_path__ + "img/icon_l_gq.27970028.png";